import { createContext } from 'react'


export type RouterState = Readonly<{
  [key: string]: string
}>

export type RouterActions = Readonly<{
  goto: (key: string, value: string) => void
  replace: (key: string, value: string | void) => void
}>

export type Context = [RouterState, RouterActions]

const defaultContext: Context = [{
}, {
  goto: () => {},
  replace: () => {}
}]

export default createContext(defaultContext)
